module.exports = __webpack_public_path__ + "static/media/NextDisabled-wo-background.2b2d2e77.svg";